import { Immutable } from "immer";
import React from "react";

import type { OfferBannerBlock as Value } from "@reactivated";

import { RichTextBlock } from "@thelabnyc/thelabui/src/components/RichText";
import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { getSpacingClasses } from "../spacing";

type Props = Immutable<{
    value: Value;
}>;

export const OfferBannerBlock = (props: Props): React.JSX.Element => {
    const v = props.value;
    return (
        // Legacy: outer `.offer-banner-block` div also carries the spacing
        // sub-block classes (space-separated). With no spacing configured
        // getSpacingClasses returns "" so only the base class is emitted.
        <div
            className={concatClassNames([
                "offer-banner-block",
                getSpacingClasses(v.spacing),
            ])}
        >
            <div className="l-full-width">
                <div className="offer-banner-block__content">
                    {/* Legacy `<div class="rich-text">{{ self.copy }}</div>`.
                        `copy` is a ClientRenderingBarrier RichTextBlock, so its
                        serialized value is the SERVER-rendered HTML string,
                        which Wagtail wraps in its own `<div class="rich-text">`.
                        Passing className="rich-text" to RichTextBlock emits the
                        explicit outer `.rich-text` wrapper; its innerHTML is the
                        serialized string (containing the inner `.rich-text`
                        div) — reproducing the legacy's two nested wrappers. */}
                    <RichTextBlock className="rich-text" value={v.copy ?? ""} />
                    <div
                        className={concatClassNames([
                            "offer-banner-block__bar",
                            "offer-banner-block__bar--" + (v.line_type ?? ""),
                        ])}
                    />
                </div>
            </div>
        </div>
    );
};
